require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-ios-development-project-week-student-mobile-apps.json") })
        }
      }, "path---blog-ios-development-project-week-student-mobile-apps");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-ios-development-project-week-student-mobile-apps!./.cache/json/blog-ios-development-project-week-student-mobile-apps.json
// module id = 898
// module chunks = 231608221292675